import { importProvidersFrom } from '@angular/core';
import { Routes } from '@angular/router';
import { PreferencesModule } from '@iot-platform/data-access/users';
import { LoginComponent } from './containers/login/login.component';

export const OYAN_UI_AUTH_ROUTES: Routes = [
  {
    path: '',
    component: LoginComponent,
    providers: [importProvidersFrom(PreferencesModule)]
  }
];
